import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  font-size: 64px;
  position: relative;
  top: -20px;
  font-weight: 700;
  margin: 0;
`;

export const Description = styled.h2`
  font-weight: 400;
  width: 68%;
  text-align: center;
  font-size: 32px;
  position: relative;
  top: -30px;
`;

export const Icon = styled.img`
  height: 319px;
  width: 249px;
  position: absolute;
  bottom: 7%;
  right: 2%;
`
